export const CircleButtonAnimation = ($button) => {
  const circle = $button.find('circle.circle');

  if(circle.length > 0) {

    let animation = new TimelineMax({paused: true });

    animation.to(circle, 1, {
      ease: Power0.easeNone,
      strokeDashoffset: 0,
      onComplete: function() {
        completedCircle($button, animation)
      }
    });

    $button.on({
      mouseenter: (e) => {
        enterState(e, animation);
      },

      mouseleave: (e) => {
        leaveState(e, animation);
      },

      click: (e) => {
        clickState(e, animation);
      }
    })

  }
}

const clickState = (e, animation) => {
  animation.timeScale( 3 );

  if($(e.currentTarget).hasClass('active')) {
    $(e.currentTarget).removeClass('active');
    animation.reverse();
  } else {
    $(e.currentTarget).addClass('active');
    animation.play();
  }
}

const enterState = (e, animation) => {
  window.circleAnimComplete = false;
  animation.play();
  animation.timeScale( .5 );
}


const leaveState = (e, animation) => {
  window.circleAnimComplete = false;
  animation.timeScale( 3 );

  if($(e.currentTarget).hasClass('active')) {
    animation.timeScale( 3 );
  } else {
    animation.reverse();
  }
}

const completedCircle = ($button, animation) => {
  window.circleAnimComplete = true;

  if($button.hasClass('tooltip-btn')) {
    $button.closest('.tooltip').addClass('show');
    $button.addClass('active');
    return;
  }

  $button.trigger('click');

  if( $button.hasClass('play-video') ||
      $button.hasClass('video-close') ||
      $button.hasClass('circle-btn') ||
      $button.hasClass('close-slider') ) {
    $button.removeClass('active');

    animation.pause();

    setTimeout(() => {
      animation.progress(0);
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/CircleButtonAnimation.js